<template>
  <div style="width: 100%; height: 100%">
    <el-row type="flex" class="row-bg" justify="end" style="width: 100%; flex-wrap: wrap;">
      <template v-if="USE_PRINT_TEMPLATE == 0">
        <template v-if="printStatus === 1">
          <template v-if="companyID !== 100">
            <el-button size="small" style="margin-right: 20px; margin-top: 30px" type="primary" @click="payablePrint">
              抬头打印
            </el-button>
            <el-button size="small" style="margin-right: 20px; margin-top: 30px" type="primary" @click="shortPreview(1)">
              短送货单打印(有备注)
            </el-button>
            <el-button size="small" style="margin-right: 20px; margin-top: 30px" type="primary" @click="shortPreview(0)">
              短送货单打印(无备注)
            </el-button>
            <el-button size="small" style="margin-right: 20px; margin-top: 30px" type="primary" @click="preview(1)">
              送货数量打印
            </el-button>
            <el-button size="small" style="margin-right: 20px; margin-top: 30px" type="primary" @click="preview(0)">
              打印预览
            </el-button>
            <el-button size="small" style="margin-right: 20px; margin-top: 30px" type="primary" @click="noCodePreview(0)">
              打印预览(无编码)
            </el-button>
            <el-button size="small" style="margin-right: 20px; margin-top: 30px" type="primary" @click="previewCustom">
              打印预览(客户编码)
            </el-button>
          </template>
          <el-button size="small" style="margin-right: 20px; margin-top: 30px" type="primary" @click="previewSpecial">
            打印五联单
          </el-button>
        </template>
        <el-button size="small" style="margin-right: 20px; margin-top: 30px" type="primary" @click="websitePricePrint" v-show="fun_dic[100020104]">
          对标网站价格打印
        </el-button>
      </template>
      <el-button size="small" style="margin-right: 20px; margin-top: 30px" type="primary" @click="previewPrint" v-if="this.USE_PRINT_TEMPLATE == 1">
        打印预览
      </el-button>
    </el-row>
    <el-row>
      <el-col v-show="this.printStatus === 1">
        <el-button size="small" type="danger" @click="haveCheck">导出</el-button>
        <span style="color: red">注：点击“导出”按钮后，订单将从“待送”状态变为“待确认”状态，请谨慎使用</span>
      </el-col>
    </el-row>
    <el-row :data="data">
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li><span>供应商</span>：{{ data[0].SUPPLIER_NAME }}</li>
          <li><span>项目点</span>：{{ data[0].PROJECT_NAME }}</li>
          <li><span>项目点地址</span>：{{ data[0].PROJECT_ADDRESS }}</li>
          <li><span>送货日期</span>：{{ data[0].SEND_DAY }}</li>
          <li><span>订购总金额</span>：{{ data[0].TOTAL_SUPPLIER_FEE }}</li>
        </ul>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="{ span: 12, offset: 0 }" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li><span>制单人</span>：{{ managername }}</li>
          <li><span>档口</span>：{{ data[0].DK_NAME }}</li>
          <li><span>项目点电话</span>：{{ data[0].PROJECT_TELPHONE }}</li>
          <li><span>订单编号</span>：{{ data[0].ORDER_CODE }}</li>
          <li><span>订单备注</span>：{{ data[0].ORDER_COMMENT }}</li>
        </ul>
      </el-col>
    </el-row>
    <!-- 远程查询和添加数据-->
    <el-form size="small" :inline="true" class="demo-form-inline" style="margin: 0" :model="firstFormadd" ref="firstFormadd" @submit.native.prevent
      v-if="orderAdjust">
      <el-form-item label="产品名称：" prop="productName">
        <el-autocomplete @keyup.enter.native="handelTab(1, $event)" ref="input1" class="inline-input" v-model="firstFormadd.productName"
          :fetch-suggestions="querySearchadd" placeholder="输入产品名称添加" :trigger-on-focus="false" @select="handleSelect" clearable :debounce="500"
          @clear="onAutocompleteClear">
        </el-autocomplete>
      </el-form-item>
      <el-form-item label="单价：">
        <el-input @keyup.enter.native="handelTab(2, $event)" ref="input2" v-model="addForm.PRICE" :disabled="isisdisabled"></el-input>
      </el-form-item>
      <el-form-item label="订购数量：">
        <el-input @keyup.enter.native="handelTab(3, $event)" ref="input3" v-model="addForm.count"></el-input>
      </el-form-item>
      <el-form-item label="备注：">
        <label slot="label">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</label>
        <el-input @keyup.enter.native="handelTabSp" ref="input4" v-model="addForm.comment" maxlength="20" show-word-limit></el-input>
      </el-form-item>
      <el-button style="display: inline-block" size="small" @click="handelTabSp">确 定</el-button>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" border stripe style="width: 100%">
          <el-table-column type="index" label="序号" width="45" min-width="30"></el-table-column>
          <el-table-column label="产品编码" prop="PRODUCT_CODE"></el-table-column>
          <el-table-column label="名称" prop="SHORT_NAME" min-width="100"></el-table-column>
          <el-table-column label="品牌" prop="BRAND" min-width="100"></el-table-column>
          <el-table-column label="规格" prop="SPECIFICATION" min-width="100"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="REAL_PRICE" label="单价（元）"></el-table-column>
          <el-table-column prop="BEFORE_TAX_PRICE" label="不含税单价（元）"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="订购数量"></el-table-column>
          <el-table-column prop="NEED_COUNT" label="送货数量"></el-table-column>
          <el-table-column prop="SUPPLIER_TOTAL_FEE" label="总价（元）"></el-table-column>
          <el-table-column prop="CATALOG_NAME" label="分类"></el-table-column>
          <el-table-column prop="PRODUCT_COMMENT" label="备注"></el-table-column>
          <el-table-column label="操作" fixed="right" width="150">
            <template slot-scope="scope">
              <el-button type="text" @click="openEdit(scope.row)" v-show="fun_dic[100020103] && data[0].CONFIG_OF_DELIVERY != 1">
                修改
              </el-button>
              <el-button type="text" @click="openAllEdit(scope.row)" v-show="fun_dic[100020101]">修改全部</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row :data="data">
      <el-col>
        <p>收货时间：</p>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <p>送货员：</p>
      </el-col>
      <el-col :span="6">
        <p>项目经理：</p>
      </el-col>
      <el-col :span="6">
        <p>厨师长：</p>
      </el-col>
      <el-col :span="6">
        <p>验收人员：</p>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button @click="updateSendCont" style="margin-top: 20px; float: right" type="primary" size="small">更新送货数量
        </el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px">
      <el-col>
        <el-steps :active="this.statusFlag" finish-status="success" v-show="this.statusFlag !== 0" :space="200">
          <el-step :title="item.T" :description="item.D" v-for="item in checkData" :key="item.value"></el-step>
        </el-steps>
        <h4 v-show="this.statusFlag === 0" style="color: #e6a23c">
          暂无流程记录信息
        </h4>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-dialog title="修改产品" center :visible.sync="editFormVisible" width="600px">
          <el-form :model="editForm" ref="editForm">
            <el-form-item label="产品名称：" :label-width="formLabelWidth">
              <span>{{ name }}</span>
            </el-form-item>
            <el-form-item label="送货数量：" :label-width="formLabelWidth">
              <el-input v-model="editForm.NEED_COUNT"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button @click="submitEdit">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog title="修改全部信息" center :visible.sync="editAllFormVisible" width="600px">
          <el-form :model="editAllForm" ref="editAllForm">
            <el-form-item label="产品名称：" :label-width="formLabelWidth">
              <span>{{ Editname }}</span>
            </el-form-item>
            <el-form-item label="采购价：" :label-width="formLabelWidth">
              <el-input v-model="editAllForm.BUY_PRICE" @change="countPrice" :disabled="isisdisabled"
                oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            </el-form-item>
            <el-form-item label="报损后单价：" :label-width="formLabelWidth">
              <span> {{ editAllForm.WPRICE }}</span>
            </el-form-item>
            <el-form-item label="销售价：" :label-width="formLabelWidth">
              <el-input v-model="editAllForm.REAL_PRICE" @change="RealPrice" :disabled="isisdisabled"
                oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            </el-form-item>
            <el-form-item label="订购数量：" :label-width="formLabelWidth">
              <el-input v-model="editAllForm.PRODUCT_COUNT" @change="ProductCount"></el-input>
            </el-form-item>
            <el-form-item label="备注：" :label-width="formLabelWidth">
              <el-input v-model="editAllForm.PRODUCT_COMMENT"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="closeAll">取 消</el-button>
            <el-button @click="submitEditAll">确 定</el-button>
          </div>
        </el-dialog>
        <!-- 抬头打印 -->
        <el-dialog title="抬头信息" center :visible.sync="payableFormVisible" width="600px">
          <el-form :model="payableForm" ref="payableForm">
            <el-form-item label="抬头信息：" :label-width="formLabelWidth">
              <el-input v-model="payableForm.NAME"></el-input>
            </el-form-item>
            <el-form-item label="打印类型：" :label-width="formLabelWidth">
              <el-radio v-model="payableForm.TYPE" label="1">短打印</el-radio>
              <el-radio v-model="payableForm.TYPE" label="2">长打印</el-radio>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="closePayable">取 消</el-button>
            <el-button @click="submitPayable">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog title="打印预览" center :visible.sync="productionDateOnlineDialog" width="600px" @close="cancelPreviewPrint">
          <el-form :model="productionDateOnlineForm" ref="productionDateOnlineForm">
            <el-form-item label="生产日期：" :label-width="formLabelWidth">
              <el-date-picker v-model="productionDateOnlineForm.PRODUCTION_DATE" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" clearable
                style="width: 100% !important;">
              </el-date-picker>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="productionDateOnlineDialog = false">取 消</el-button>
            <el-button @click="submitPreviewPrint">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  exportOrderFun, updateNewDetailFun_Limit, orderDetailFun, updatePrintOrderFun, updatesendCountFun, notOrderDetailFun, updateOrderFun, priceCountFun,
} from 'api/sellOrder';

import { getActionFun } from 'api/login';
import bus from '@/assets/common/bus';
import http from '@/assets/common/http';
import util from '@/assets/common/util';
import { unitManageFun } from '@/assets/api/systemSetting';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      fromName: ['sellOrderCustomPrintDetail', 'websitePricePrint', 'sellOrderFivePrint', 'printPreviewCustom', 'sellOrderPrint', 'NewOrderList'],
      toName: ['sellOrderCustomPrintDetail', 'websitePricePrint', 'sellOrderFivePrint', 'printPreviewCustom', 'sellOrderPrint'],
      managername: sessionStorage.getItem('name'),
      tableData: [],
      name: '',
      data: [{
        SUPPLIER_NAME: '',
        PROJECT_ADDRESS: '',
        ORDER_CODE: '',
        PROJECT_NAME: '',
        SEND_DAY: '',
        PROJECT_TELPHONE: '',
        DK_NAME: '',
        ORDER_COMMENT: '',
      }],

      printStatus: '',
      formLabelWidth: '100px',
      editFormVisible: false,
      editForm: {},
      addForm: {},
      companyID: Number(sessionStorage.getItem('tcId')),
      ORDER_ID: sessionStorage.getItem('orderId'),
      ORDER_DETAIL_ID: '',
      checkData: [],
      statusFlag: 0,
      editAllFormVisible: false,
      editAllForm: {},
      Editname: '',
      addPoint: 0,
      PAGE_ID: '1000201', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 100020101: 0, 100020103: 0, 100020104: 0 },
      firstFormadd: {
        productName: '',
      },
      CAN_MODIFY_PRICE: sessionStorage.getItem('CAN_MODIFY_PRICE'),
      userPriceType: sessionStorage.getItem('PRICE_MODE'),
      isisdisabled: false,
      payableFormVisible: false,
      payableForm: {
        TYPE: '1',
      },
      USE_PRINT_TEMPLATE: 0,
      payableName: '',
      orderAdjust: 0,
      productionDateOnlineDialog: false,
      productionDateOnlineForm: {
        PRODUCTION_DATE: '',
      },
    };
  },
  beforeDestroy() {
    sessionStorage.removeItem('ORDER_TC_ID');
  },
  methods: {
    // 是否使用模板
    queryForm() {
      const params = {
        SERVICE_ID: '12013',
        OTYPE: 7,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        IS_SUPPLIER_CLIENT: 0,
        TC_ID: this.companyID,
      };
      http.post(params).then((result) => {
        this.USE_PRINT_TEMPLATE = result[0].USE_PRINT_TEMPLATE;
        this.templateContent = result[0].TEMPLATE_CONTENT;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    previewPrint() {
      sessionStorage.setItem('TEM_TCID', this.companyID);
      if (this.templateContent[0] && this.templateContent[0].tableSet.includes('生产日期(线上填写)')) {
        this.productionDateOnlineDialog = true;
      } else this.submitPreviewPrint();
    },
    submitPreviewPrint() {
      sessionStorage.setItem('未签收销售单打印 生产日期(线上填写)', this.productionDateOnlineForm.PRODUCTION_DATE);
      this.$router.push({ name: 'sellOrderCustomPrintDetail' });
    },
    cancelPreviewPrint() {
      this.$refs.productionDateOnlineForm.resetFields();
    },
    // 抬头打印
    payablePrint() {
      this.payableFormVisible = true;
    },
    closePayable() {
      this.payableFormVisible = false;
      this.payableForm = {};
    },
    submitPayable() {
      if (this.payableForm.NAME) {
        this.payableName = this.payableForm.NAME;
        sessionStorage.setItem('payableName', this.payableName);
      } else {
        this.$message.show({ text: '请输入抬头信息', type: 'warning' });
        return;
      }
      if (this.payableForm.TYPE === '1') {
        this.shortPreview(1);
      } else if (this.payableForm.TYPE === '2') {
        this.preview(0);
      }
    },
    // input框回车自动聚焦下一个input框
    handelTab(i, e) {
      const that = this;
      if (that.$refs[`input${i}`]) {
        that.$nextTick(() => {
          e.target.blur();
          const index = i + 1;
          that.$refs[`input${index}`].focus();
        });
      }
    },
    // 提交手动录入数据以及重新聚焦第一个input框
    handelTabSp(e) {
      if (Number(this.addForm.count) == 0) {
        this.$message.show({ text: '请输入正确的数量', type: 'error' });
        return false;
      }
      this.submitAdd();
      const that = this;
      e.target.blur();
      that.$refs.input1.focus();
    },
    querySearchadd(queryString, callback) {
      this.$_getSearchRushOrderList1(queryString).then((res) => {
        const tmpArr = res.map((item) => ({
          CATALOG_NAME: item.CATALOG_NAME,
          NAME: item.NAME,
          PRICE: item.PRICE,
          PRODUCT_CODE: item.PRODUCT_CODE,
          TYPE_UNIT: item.TYPE_UNIT,
        }));
        const results = tmpArr.map((item) => {
          item.value = `${item.NAME}(${item.TYPE_UNIT})`;
          return item;
        });
        callback(results);
      });
    },
    // 挑选
    handleSelect(item) {
      this.addForm = item;
    },
    $_getSearchRushOrderList1() {
      const data = {
        SERVICE_ID: '10013',
        OTYPE: 16,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        PRODUCT_NAME: this.firstFormadd.productName,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PROJECT_ID: Number(sessionStorage.getItem('projectid')),
        SEND_DAY: sessionStorage.getItem('sendDay'),
        PRICE_MODE: sessionStorage.getItem('PRICE_MODE'),
      };
      return new Promise((resolve, reject) => {
        http.post(data).then((res) => {
          resolve(res[0].list);
        });
      });
    },
    // ---------------------------添加·产品·确认·按钮
    submitAdd() {
      if (!this.firstFormadd.productName) {
        this.$message.show({ text: '请输入产品名称', type: 'warning' });
        return false;
      }
      if ((this.$util.JudgmentUnit(this.addForm.TYPE_UNIT) ? !validation.数量正数0验证(this.addForm.count) : !validation.数量整数正数0验证(this.addForm.count)) || !validation.价格正数0验证(this.addForm.PRICE)) {
        this.$message.show({ text: '请输入正数的数量和价格', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10004',
        OTYPE: 2,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        ORDER_ID: sessionStorage.getItem('orderId'),
        PRODUCT_COUNT: this.addForm.count,
        PRODUCT_CODE: this.addForm.PRODUCT_CODE,
      };
      if (this.addForm.PRICE) {
        params.PRICE = this.addForm.PRICE;
      }
      if (this.addForm.comment) {
        params.PRODUCT_COMMENT = this.addForm.comment;
      }
      http.post(params).then((result) => {
        this.$message.show({ text: '新增成功', type: 'success' });
        this.addFormVisible = false;
        this.queryTable();
        this.firstFormadd.productName = '';
        this.addForm = {};
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.firstFormadd.productName = '';
        this.addForm = {};
      });
    },
    // --------------------------------页面加载完成请求的订单详情数据
    queryTable() {
      const params = {
        ORDER_ID: Number(sessionStorage.getItem('orderId')),
      };
      orderDetailFun(params).then((result) => {
        if (result[0].DETAIL.length !== 0) {
          this.tableData = result[0].DETAIL.map((item) => ({ ...item, BEFORE_TAX_PRICE: Number(item.BEFORE_TAX_PRICE).toFixed(2) }));
          this.orderFee = result[0].TITLE[0].TOTAL_SUPPLIER_FEE;
        } else {
          this.tableData = [];
          this.orderFee = 0;
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // --------------------------------查看订单详情
    queryOrderDetailListData() {
      const params = {
        ID: Number(this.ORDER_ID),
      };
      notOrderDetailFun(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result.length > 0 ? result[0].DETAIL.map((item) => ({ ...item, BEFORE_TAX_PRICE: Number(item.BEFORE_TAX_PRICE).toFixed(2) })) : [];
          this.data = result.length > 0 ? result[0].TITLE : [];
          this.checkData = result.length > 0 ? result[0].OR[0].DATA : [];
          this.statusFlag = result.length > 0 ? result[0].OR[0].RN : 0;
          this.printStatus = result[0].PRINT_FLAG;
          // ---------------------------------------获取判断的companyID
          this.companyID = result[0].TITLE[0].TC_ID;
          this.addPoint = result[0].TITLE[0].ADD_POINT;
          if (result[0].TITLE[0].AGENT) {
            sessionStorage.setItem('AGENT', result[0].TITLE[0].AGENT);
          } else {
            sessionStorage.setItem('AGENT', 0);
          }
          this.queryForm();
        } else {
          this.$router.push({ name: 'NewOrderList' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    preview(flag) {
      if (this.compareMonths('打印')) {
        // 打印流程跳转前备份筛选记忆，供打印页整页刷新后恢复 vuex
        this.$store.dispatch('backupFilterMemory');
        this.$router.push({ name: 'sellOrderPrint' });
        sessionStorage.setItem('countFlag', flag); // 0表示打印订购数量,1表示打印送货数量
        sessionStorage.setItem('isShortDocFlag', 0);
        sessionStorage.setItem('printRealFlag', 0);
      }
    },
    noCodePreview(flag) {
      if (this.compareMonths('打印')) {
        this.$router.push({ name: 'sellOrderPrint' });
        sessionStorage.setItem('countFlag', flag); // 0表示打印订购数量,1表示打印送货数量
        sessionStorage.setItem('isShortDocFlag', 0);
        sessionStorage.setItem('printRealFlag', 0);
        sessionStorage.setItem('noCode', 1);
      }
    },
    shortPreview(num) {
      if (this.compareMonths('打印')) {
        this.$router.push({ name: 'sellOrderPrint', params: { remarks: num } });
        sessionStorage.setItem('countFlag', 1);
        sessionStorage.setItem('isShortDocFlag', 1);
        sessionStorage.setItem('printRealFlag', 0);
      }
    },
    previewCustom() {
      if (this.compareMonths('打印')) {
        this.$router.push({ name: 'printPreviewCustom' });
        sessionStorage.setItem('sendFlag', 0);
      }
    },
    openEdit(row) {
      this.editFormVisible = true;
      this.editForm = row;
      this.name = row.PRODUCT_NAME;
      this.ORDER_DETAIL_ID = row.ORDER_DETAIL_ID;
    },
    submitEdit() {
      if (util.JudgmentUnit(this.editForm.TYPE_UNIT)) {
        if (!validation.数量正数0验证(this.editForm.NEED_COUNT)) {
          this.$message.show({ text: '请输入正确的送货数量', type: 'warning' });
          return false;
        }
      } else if (!validation.数量整数正数0验证(this.editForm.NEED_COUNT)) {
        this.$message.show({ text: '请输入正确的送货数量', type: 'warning' });
        return false;
      }
      const params = {
        DETAIL_ID: this.ORDER_DETAIL_ID,
        NEED_COUNT: Number(this.editForm.NEED_COUNT),
        TC_ID: Number(sessionStorage.getItem('ORDER_TC_ID')),
      };
      updateNewDetailFun_Limit(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.editFormVisible = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.editFormVisible = false;
        this.queryOrderDetailListData();
      });
    },
    close() {
      this.editFormVisible = false;
      this.queryOrderDetailListData();
    },
    // ----------------------------------------导出当前订单
    haveCheck() {
      if (this.compareMonths('导出')) {
        this.changeStatus();
        this.export();
      }
    },
    export() {
      const orderParams = {
        ORDER_ID: sessionStorage.getItem('orderId'),
      };
      exportOrderFun(orderParams)
        .then((result) => {
          this.$message.show({ text: '导出成功', type: 'success' });
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
          this.$router.push({ name: 'NewOrderList' });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // --------------------------------------改变状态
    changeStatus() {
      const params = {
        ORDER_ID: sessionStorage.getItem('orderId'),
      };
      updatePrintOrderFun(params)
        .then((result) => {
          this.$message.show({ text: '操作成功', type: 'success' });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    openAllEdit(row) {
      this.editAllFormVisible = true;
      this.editAllForm = JSON.parse(JSON.stringify(row));
      this.Editname = row.PRODUCT_NAME;
    },
    submitEditAll() {
      if (util.JudgmentUnit(this.editAllForm.TYPE_UNIT)) {
        if (!validation.数量正数0验证(this.editAllForm.PRODUCT_COUNT)) {
          this.$message.show({ text: '请输入正确的订购数量', type: 'warning' });
          return false;
        }
      } else if (!validation.数量整数正数0验证(this.editAllForm.PRODUCT_COUNT)) {
        this.$message.show({ text: '请输入正确的订购数量', type: 'warning' });
        return false;
      }
      if (!validation.价格正数0验证(this.editAllForm.REAL_PRICE)) {
        this.$message.show({ text: '请输入正确的价格', type: 'warning' });
        return false;
      }
      const params = {
        ORDER_DETAIL_ID: this.editAllForm.ORDER_DETAIL_ID,
        NEW_COUNT: Number(this.editAllForm.PRODUCT_COUNT),
        MODIFY_FLAG: 1,
        PRICE: this.editAllForm.REAL_PRICE,
        PRODUCT_COMMENT: this.editAllForm.PRODUCT_COMMENT,
        SUPPLIER_ID: this.data[0].SUPPLIER_ID,
        PRODUCT_CODE: this.editAllForm.PRODUCT_CODE,
      };
      if (!this.editAllForm.REAL_PRICE || !this.editAllForm.PRODUCT_COUNT) {
        this.$message.show({ text: '请输入销售价和订购数量', type: 'warning' });
        return false;
      }
      updateOrderFun(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.editAllFormVisible = false;
        this.queryOrderDetailListData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    closeAll() {
      this.editAllFormVisible = false;
    },
    Price(e) {
      this.addForm.PRICE = e;
    },
    Count(e) {
      this.addForm.count = e;
    },
    NeedCount(e) {
      this.editForm.NEED_COUNT = e;
    },
    RealPrice(e) {
      this.editAllForm.REAL_PRICE = e;
    },
    ProductCount(e) {
      this.editAllForm.PRODUCT_COUNT = e;
    },
    countPrice() {
      if (validation.价格正数验证(this.editAllForm.BUY_PRICE)) {
        const params = {
          PRICE: this.editAllForm.BUY_PRICE,
          CATALOG_ID: this.editAllForm.CATALOG_ID,
        };
        priceCountFun(params)
          .then((result) => {
            this.editAllForm.REAL_PRICE = result[0];
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      } else {
        this.$message.show({ text: '请输入正数的采购价', type: 'warning' });
        this.editAllForm.BUY_PRICE = '';
      }
    },
    updateSendCont() {
      const params = {
        ORDER_ID: sessionStorage.getItem('orderId'),
      };
      updatesendCountFun(params)
        .then((result) => {
          this.$message.show({ text: '操作成功', type: 'success' });
          this.queryOrderDetailListData();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 平昌的特殊形式打印
    previewSpecial() {
      if (this.compareMonths('打印')) {
        this.$router.push({ name: 'sellOrderFivePrint' });
      }
    },
    // 比较月份
    compareMonths(text) {
      if (this.data[0].TC_STATUS == 1) {
        const sendDate = new Date(this.data[0].SEND_DAY);
        const currentDate = new Date();

        const diffMonth = currentDate.getMonth() - sendDate.getMonth();

        if (sendDate.getYear() < currentDate.getYear()
          || (sendDate.getYear() == currentDate.getYear() && sendDate.getMonth() < currentDate.getMonth() && new Date().getDate() > 10)
          || (sendDate.getYear() == currentDate.getYear() && sendDate.getMonth() < currentDate.getMonth() && new Date().getDate() < 10 && diffMonth > 1)) {
          this.$message.show({ text: `根据公司要求，跨月订单无法${text}，请联系项目点处理`, type: 'warning' });
          return false;
        }
      }
      return true;
    },
    getOrderAdjust() {
      unitManageFun().then((result) => {
        this.orderAdjust = result[0].ORDER_ADJUST;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    websitePricePrint() {
      const params = {
        SERVICE_ID: '10051',
        OTYPE: 11,
        GYS_ID: sessionStorage.getItem('tcId'),
      };
      http.post(params).then((res) => {
        this.$prompt('', '请输入乘算比例(%)', {
          confirmButtonText: '确定', cancelButtonText: '取消', inputValue: sessionStorage.getItem('websitePriceRate') ? sessionStorage.getItem('websitePriceRate') : '', center: true,
        }).then(({ value }) => {
          if (/(^([1-9]\d*)$)/.test(value)) {
            this.$router.push({ name: 'websitePricePrint' });
            sessionStorage.setItem('countFlag', 0); // 0表示打印订购数量,1表示打印送货数量
            sessionStorage.setItem('isShortDocFlag', 0);
            sessionStorage.setItem('printRealFlag', 0);
            sessionStorage.setItem('websitePriceRate', value);
          } else {
            this.$message.show({ text: '请输入正整数', type: 'warning' });
          }
        }).catch((e) => { });
      }).catch((e) => {
        this.$message.show({ text: e, type: 'error' });
      });
    },
    onAutocompleteClear() {
      this.$refs.firstFormadd.resetFields();
      document.activeElement.blur();
    },
  },
  beforeRouteLeave(to, from, next) {
    // 离开页面前清除订单ID
    if (!this.toName.includes(to.name)) {
      sessionStorage.removeItem('orderId');
    }

    next();
  },
  beforeRouteEnter(to, from, next) {
    next((that) => {
      // 判断是否通过修改URL进入
      if (!that.fromName.includes(from.name) || !sessionStorage.getItem('orderId')) {
        that.$message.show({ text: '请从待送订单列表进入订单详情', type: 'warning' });
        that.$router.go(-1);
      } else {
        // 控制是否可以自行修改价格
        if (Number(that.CAN_MODIFY_PRICE) === 1) {
          that.isisdisabled = false;
        } else {
          that.isisdisabled = true;
        }
        that.queryOrderDetailListData();
        that.queryBeforeFun();
        that.getOrderAdjust();
      }
    });
  },
  destroyed() {
    bus.$emit('submit', this.tableData);
  },
};
</script>

<style scoped>
.ma img {
  width: 105px;
}

ul {
  list-style: none;
  min-height: 100px;
  padding: 0;
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}

p {
  font-size: 14px;
}

li span {
  display: inline-block;
  width: 70px;
  text-align-last: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/newOrderDetail.vue